export const onlyNumbers = (s: string): string => {
  return s.replace(/\D/g, "");
};

export const onlyDecimalNumbers = (s: string): string => {
  return s.replace(/[^0-9.]+/g, "");
};

export const formatNumber = v => (v ? Number(v).toFixed(2) : "-");
